// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".convenio-table {\n    max-width: 80%;\n    width: 80%;\n    padding-top: 1rem;\n    margin: 0 auto;\n}", "",{"version":3,"sources":["webpack://src/pages/ConvenioList/styles.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,UAAU;IACV,iBAAiB;IACjB,cAAc;AAClB","sourcesContent":[".convenio-table {\n    max-width: 80%;\n    width: 80%;\n    padding-top: 1rem;\n    margin: 0 auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
